import React, { useEffect, useState } from 'react';
import Modal from 'shared/modals/Modal';
import { SaveButton } from 'src/shared/components/buttons';
import { FormDatePicker, FormInput } from 'src/shared/components/formControls';
import { bulkUpdateInventoryDetails } from 'src/fetch/inventoryUnit';
import { Card, CardBody, CardTitle } from '@progress/kendo-react-layout';
import toastr from 'shared/helpers/toastr';
import errorToastr from 'shared/helpers/errorToastr';

const QuantityDetailsModal = ({ onClose, dataItem, disabled, isSubmitting, setSubmitting }) => {
  const [data, setData] = useState([]);

  useEffect(() => {
    setData(getData());
  }, []);

  var groupBy = function (xs, key) {
    return xs.reduce(function (rv, x) {
      (rv[x[key]] = rv[x[key]] || []).push(x);
      return rv;
    }, {});
  };

  const getData = () => groupBy(dataItem.inventoryDetails, 'inventoryBreakdownId');

  let lineItems = data;

  const handleValueChange = (key, field, value) => {
    let currData = JSON.parse(JSON.stringify(data));
    currData[key].find((d) => d.propertyName === field).propertyValue = value;
    setData(currData);
  };

  const handleSave = () => {
    bulkUpdateInventoryDetails(Object.values(data).flat())
      .then(() => {
        toastr('success', 'Line Items Saved Successfully.');
      })
      .catch((error) => {
        console.log('Line items save error', error);
        errorToastr({
          error,
          messagePrefix: 'Line items save failed.',
        });
      });
  };

  return (
    <Modal isOpen={true} title={`Details for MR #${dataItem.id}`} handleClose={onClose} containerStyle='medium'>
      {Object.keys(lineItems).map((key, index) => {
        {
          return (
            <Card>
              <CardTitle>#{index + 1}</CardTitle>
              <CardBody style={{ padding: 0 }}>
                <div
                  style={{
                    display: 'inline-flex',
                    alignItems: 'baseline',
                    width: '100%',
                    justifyContent: 'space-evenly',
                    alignContent: 'center',
                    flexWrap: 'wrap',
                    margin: '0.5rem',
                  }}
                >
                  {lineItems[key].map((lineItem, i) => {
                    return (
                      <>
                        {lineItem.propertyName.toLocaleLowerCase().includes('date') ? (
                          <div style={{ width: '15rem' }}>
                            <FormDatePicker
                              defaultValue={lineItem.propertyValue}
                              label={lineItem.propertyName}
                              key={lineItem.propertyName}
                              onChange={(e) => handleValueChange(key, lineItem.propertyName, e.value)}
                              disabled={disabled}
                            />
                          </div>
                        ) : (
                          <div style={{ width: '15rem' }}>
                            <FormInput
                              label={lineItem.propertyName}
                              key={lineItem.propertyName}
                              value={lineItem.propertyValue}
                              onChange={(e) => handleValueChange(key, lineItem.propertyName, e.value)}
                              disabled={disabled}
                            />
                          </div>
                        )}
                      </>
                    );
                  })}
                </div>
              </CardBody>
            </Card>
          );
        }
      })}

      <SaveButton onClick={handleSave} disabled={disabled} />
    </Modal>
  );
};

export default QuantityDetailsModal;
